import { Button } from "../ui/Button";
import { Sheet, SheetContent, SheetTrigger } from "../ui/Sheet";
import { Menu } from "lucide-react";
import { SidebarNav } from "./SidebarNav";
import { UserDropdown } from "./UserDropdown";
import { useAuth } from '../../hooks/useAuth';

type MobileSidenavProps = {
    sidebarNavIncludeIds?: string[];
    sidebarNavRemoveIds?: string[];
    showOrgSwitcher?: boolean;
};

export function MobileSidenav({
    sidebarNavIncludeIds,
    sidebarNavRemoveIds,
    showOrgSwitcher,
}: MobileSidenavProps) {
    const { user } = useAuth();

    return (
        <Sheet>
            <SheetTrigger asChild>
                <Button variant="ghost" size="icon" className="lg:hidden">
                    <Menu className="h-5 w-5" />
                    <span className="sr-only">Toggle menu</span>
                </Button>
            </SheetTrigger>
            <SheetContent side="left" className="w-64 bg-card">
                <div className="flex h-full flex-col">
                    <div className="py-4">
                        <UserDropdown user={user} />
                    </div>
                    
                    <div className="flex-1 overflow-y-auto py-2">
                        <SidebarNav
                            sidebarNavIncludeIds={sidebarNavIncludeIds}
                            sidebarNavRemoveIds={sidebarNavRemoveIds}
                        />
                    </div>
                </div>
            </SheetContent>
        </Sheet>
    );
}
